
import React from "react";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';


const LicensedProductCatalog = () => (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
  <div className="bg-gray-50 min-h-screen">
    <div className=" ">
      <div className="flex items-center justify-between mb-6">
        <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="BookOpen" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Licensed Product Catalog</h1>
                <p className="text-muted mb-0 small">Track approved product categories, flag unauthorized products</p>
              </div>
</div>

        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">Licensed Product Catalog</h1>
          <p className="text-gray-500 mt-1">Track approved product categories, flag unauthorized products</p>
        </div> */}
        <div className="flex gap-2">
          <select className="border rounded-lg px-4 py-2 bg-white">
            <option>All Brands</option>
            <option>Aurora Animation</option>
            <option>Midnight Echo</option>
          </select>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">+ Add Product</button>
        </div>
      </div>

      {/* Alerts */}
      <div className="bg-red-50 border border-red-200 rounded-xl p-1 mb-6 flex items-center gap-3">
        <span className="text-2xl" role="img" aria-label="alert">🚨</span>
        <div className="flex-1">
          <p className="font-semibold text-red-800">2 Unauthorized Products Detected</p>
          <p className="text-sm text-red-600">Products found in market that are not covered by any active license</p>
        </div>
        <button className="bg-red-600 text-white px-3 py-1 rounded-lg text-sm">Review Now</button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-5 gap-4 mb-6">
        <div className="bg-white rounded-xl shadow p-4 text-center"><p className="text-2xl font-bold text-blue-600">156</p><p className="text-xs text-gray-500">Total Products</p></div>
        <div className="bg-white rounded-xl shadow p-4 text-center"><p className="text-2xl font-bold text-green-600">142</p><p className="text-xs text-gray-500">Approved</p></div>
        <div className="bg-white rounded-xl shadow p-4 text-center"><p className="text-2xl font-bold text-yellow-600">8</p><p className="text-xs text-gray-500">Pending Approval</p></div>
        <div className="bg-white rounded-xl shadow p-4 text-center"><p className="text-2xl font-bold text-red-600">2</p><p className="text-xs text-gray-500">Unauthorized</p></div>
        <div className="bg-white rounded-xl shadow p-4 text-center"><p className="text-2xl font-bold text-gray-600">4</p><p className="text-xs text-gray-500">Discontinued</p></div>
      </div>

      {/* Category Grid */}
      <div className="bg-white rounded-xl shadow p-6 mb-6">
        <h5 className="text-lg font-semibold mb-4">Aurora Animation — Product Categories by Licensee</h5>
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[700px]">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-3 text-left">Licensee</th>
                <th className="p-3 text-center">Apparel</th>
                <th className="p-3 text-center">Toys</th>
                <th className="p-3 text-center">Home Decor</th>
                <th className="p-3 text-center">Stationery</th>
                <th className="p-3 text-center">Digital</th>
                <th className="p-3 text-center">Food & Bev</th>
                <th className="p-3 text-center">Accessories</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="p-3 font-medium">Summit Ridge Merch</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">32 SKUs</span></td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">18 SKUs</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">8 SKUs</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">12 SKUs</span></td>
              </tr>
              <tr className="border-t">
                <td className="p-3 font-medium">Golden State Apparel</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">45 SKUs</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center"><span className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded text-xs">Pending</span></td>
              </tr>
              <tr className="border-t bg-red-50">
                <td className="p-3 font-medium">Bright Star Retail</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">15 SKUs</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">6 SKUs</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center text-gray-300">—</td>
                <td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-semibold">UNAUTHORIZED</span></td>
                <td className="p-3 text-center text-gray-300">—</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Unauthorized Products Detail */}
      <div className="bg-white rounded-xl shadow p-6">
        <h5 className="text-lg font-semibold mb-4 text-red-700">Unauthorized Product Alerts</h5>
        <div className="space-y-4">
          <div className="flex gap-4 p-4 border border-red-200 rounded-lg bg-red-50">
            <div className="w-20 h-20 bg-red-200 rounded-lg flex items-center justify-center text-3xl" role="img" aria-label="candy">🍬</div>
            <div className="flex-1">
              <p className="font-semibold">Aurora Gummy Bears — Bright Star Retail</p>
              <p className="text-sm text-gray-600">Category: Food & Beverage | Detected: Mar 15, 2026</p>
              <p className="text-sm text-red-600 mt-1">This licensee is NOT authorized for Food & Beverage products. License covers Apparel and Home Decor only (Contract Section 2.1)</p>
            </div>
            <div className="flex flex-col gap-2">
              <button className="bg-red-600 text-white px-3 py-1 rounded text-sm">Send C&amp;D</button>
              <button className="border px-3 py-1 rounded text-sm">Negotiate</button>
            </div>
          </div>
          <div className="flex gap-4 p-4 border border-red-200 rounded-lg bg-red-50">
            <div className="w-20 h-20 bg-red-200 rounded-lg flex items-center justify-center text-3xl" role="img" aria-label="mobile">📱</div>
            <div className="flex-1">
              <p className="font-semibold">Aurora Mobile Game App — Unknown Publisher</p>
              <p className="text-sm text-gray-600">Category: Digital | Detected: Mar 22, 2026</p>
              <p className="text-sm text-red-600 mt-1">No active license covers digital/mobile game products for Aurora Animation. Possible IP infringement.</p>
            </div>
            <div className="flex flex-col gap-2">
              <button className="bg-red-600 text-white px-3 py-1 rounded text-sm">Investigate</button>
              <button className="border px-3 py-1 rounded text-sm">Legal Action</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></div></div></div></div>
);

export default LicensedProductCatalog;
